export enum Environment {
  PRODUCTION = 'production',
  PRODUCTION_UK = 'production_uk',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
  LOCAL = 'local',
}
